export default {
  MuiTypography: {
    root: {
      paddingTop: '3px',
    },
    body2: {
      paddingTop: '3px',
    },
  },
};
